export const filterPropsMark = ["marka", "model", "kuzov"];

export const filterPropsTop = [
  "tip_kuzova",
  "complectacia",
  "mestopolozhenie",
  "vneshniy_vid",
  "technical_parameter",
];

export const filterProps = [
  "tip_kryuka",
  "vyrez_bampera",
  "proizvoditel",
  "price",
  "vertikalnaya_nagruzka",
  "tyagovaya_nagruzka_kg",
  "elektrika_v_komplekte",
  "kol_vo_kontaktov",
  "kolicestvo_velosipedov",
  "tsvet_1",
  "tip_dugi",
  "tip_krepleniya",
];

export const filterSliderProps = ["price"];

export const installPropNames = {
  VREMYA_USTANOVKI: "Без электрики",
  FARKOP_SHTATKA: "Фаркоп + штатка",
  FARKOP_EL: "Фаркоп + эл.",
  FARKOP_BLOK: "Фаркоп + блок",
  FARKOP_13P_EL: "Фаркоп + 13п.эл.",
  PODKLYUCHENIE_ELEKTRIKI: "Подключение электрики",
  PODKLYUCHENIE_BLOKA: "Подключение блока",
  PODKLYUCHENIE_SHTATKI: "Подключение штатки",
};
